import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { ViewGoalsPage } from './view-goals.page';
import { DashboardService } from '../../dashboard.service';
import { UtilService } from 'src/app/shared/services/util.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        PipesModule
    ],
    declarations: [
        ViewGoalsPage
    ],
    providers: [
        DashboardService,
        UtilService
    ]
})
export class ViewGoalsModule { }
